import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { trackEvent } from "../lib/analytics";

// WhatsApp phone number — E.164 format without '+' or spaces
const WA_NUMBER = "447376306726";
const WA_MESSAGE = "Hi Mixing Dreams! I'd like to know more about your services.";

export const WhatsAppButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Appear after hero animation completes
    const t = setTimeout(() => setVisible(true), 1600);
    return () => clearTimeout(t);
  }, []);

  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-fab"
          aria-label="Chat on WhatsApp"
          onClick={() => trackEvent("whatsapp_click", { source: "floating_button" })}
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.95 }}
          className="fixed bottom-6 right-6 z-[9998] flex h-14 w-14 items-center justify-center rounded-full text-white shadow-2xl"
          style={{
            background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
            boxShadow: "0 10px 30px -5px rgba(37, 211, 102, 0.5), 0 0 0 1px rgba(255,255,255,0.08)",
          }}
        >
          {/* Pulsing ring */}
          <span
            className="absolute inset-0 rounded-full"
            style={{
              animation: "wa-pulse 2.2s ease-out infinite",
              boxShadow: "0 0 0 0 rgba(37, 211, 102, 0.6)",
            }}
          />
          {/* WhatsApp glyph (official-style) */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            fill="currentColor"
            className="relative h-7 w-7"
            aria-hidden="true"
          >
            <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.828 1.23 1.964 2.586 3.5 4.663 4.535.717.372 2.72 1.09 3.495 1.09.66 0 2.15-.402 2.478-1.096.2-.415.2-.79.114-1.234-.13-.71-2.522-1.256-2.98-1.256zM16.223 6.437c-5.62 0-10.145 4.525-10.145 10.145a10.05 10.05 0 0 0 1.503 5.334L6 26.542l4.79-1.593c1.618.917 3.5 1.376 5.435 1.376 5.62 0 10.145-4.525 10.145-10.145s-4.525-9.743-10.145-9.743zm0 18.146a8.29 8.29 0 0 1-4.24-1.146l-.302-.187-2.98.995.976-2.923-.202-.316a8.394 8.394 0 0 1-1.318-4.535c0-4.677 3.797-8.474 8.474-8.474 4.677 0 8.474 3.797 8.474 8.474 0 4.677-3.797 8.474-8.474 8.474z"/>
          </svg>
          {/* Tooltip on hover (desktop) */}
          <span
            className="hidden md:block absolute right-full mr-3 whitespace-nowrap rounded-full bg-black/90 border border-white/10 px-4 py-2 text-xs font-medium tracking-wide text-white opacity-0 group-hover:opacity-100 pointer-events-none"
            style={{ transition: "opacity .3s" }}
          >
            Chat on WhatsApp
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppButton;
